import cn from "clsx";
import React, { HTMLAttributes } from "react";
import { Text } from "../../text";
import styles from "../Table.module.scss";

export type CaptionProps = React.PropsWithChildren<{
    /**
     * Displays the table caption
     * @default false
     */
    showTitle?: boolean;
}> &
    HTMLAttributes<HTMLTableCaptionElement>;

export const TableCaption: React.FC<CaptionProps> = ({
    showTitle = false,
    children,
    className = "",
    ...captionProps
}) => {
    return (
        <Text.Body
            tag="caption"
            className={cn(styles.caption, className, {
                "visually-hidden": !showTitle,
            })}
            {...captionProps}
        >
            {children}
        </Text.Body>
    );
};
